/* Product Upsell — externalized from snippets/product-upsell.liquid (logic
   unchanged). The fallback currency comes from the JSON config block
   <script type="application/json" data-product-upsell-config>.
   Requires sneak-money.js for price formatting. */
(function() {
  if (window.__sneakProductUpsellLoaded) return;
  window.__sneakProductUpsellLoaded = true;

  function init() {
    const upsellBlock = document.querySelector('.product-upsell');
    if (!upsellBlock || upsellBlock.dataset.upsellReady) return;
    upsellBlock.dataset.upsellReady = '1';

    let fallbackCurrency = 'EUR';
    try {
      const cfgEl = document.querySelector('[data-product-upsell-config]');
      if (cfgEl) fallbackCurrency = JSON.parse(cfgEl.textContent).currency || 'EUR';
    } catch (e) {}

    const checkbox = upsellBlock.querySelector('.product-upsell__checkbox');
    const hasVariants = upsellBlock.dataset.hasVariants === 'true';
    const dropdownWrap = document.getElementById(`upsell-variant-${upsellBlock.dataset.upsellProductId}`);
    const dropdownTrigger = dropdownWrap ? dropdownWrap.querySelector('[data-upsell-dropdown-trigger]') : null;
    const dropdownList = dropdownWrap ? dropdownWrap.querySelector('[data-upsell-dropdown-list]') : null;
    const dropdownLabel = dropdownWrap ? dropdownWrap.querySelector('[data-upsell-dropdown-label]') : null;
    const productId = upsellBlock.dataset.upsellProductId;

    let currentVariantId = checkbox ? checkbox.dataset.upsellVariantId : null;
    let currentPrice = checkbox ? parseInt(checkbox.dataset.upsellPrice) : 0;

    // Function to handle variant change
    function handleVariantChange(pill) {
      if (!pill || !pill.dataset.variantId) {
        if (checkbox) {
          checkbox.disabled = true;
          checkbox.checked = false;
        }
        updateUpsellState(false);
        return;
      }

      currentVariantId = pill.dataset.variantId;
      currentPrice = parseInt(pill.dataset.price);
      const compareAtPrice = parseInt(pill.dataset.compareAt);
      const variantImage = pill.dataset.image;

      // Update product image if variant has a different image
      if (variantImage) {
        const imageContainer = upsellBlock.querySelector('.product-upsell__image');
        if (imageContainer) {
          const existingImg = imageContainer.querySelector('img');
          if (existingImg) {
            existingImg.src = variantImage;
            existingImg.alt = pill.dataset.title || upsellBlock.querySelector('.product-upsell__title')?.textContent || '';
          } else {
            const img = document.createElement('img');
            img.src = variantImage;
            img.alt = pill.dataset.title || '';
            img.loading = 'lazy';
            const placeholder = imageContainer.querySelector('.product-upsell__placeholder');
            if (placeholder) {
              placeholder.replaceWith(img);
            } else {
              imageContainer.innerHTML = '';
              imageContainer.appendChild(img);
            }
          }
        }
      }

      // Update price display using price-list elements
      const pricingWrap = document.getElementById(`upsell-pricing-${productId}`);
      if (pricingWrap) {
        const salePrice = pricingWrap.querySelector('sale-price');
        const compareAt = pricingWrap.querySelector('compare-at-price');
        const badge = pricingWrap.querySelector('on-sale-badge');

        if (salePrice) {
          salePrice.textContent = formatMoney(currentPrice);
          if (compareAtPrice > currentPrice && compareAtPrice > 0) {
            salePrice.className = 'text-on-sale text-sm';
          } else {
            salePrice.className = 'text-subdued text-sm';
          }
        }

        if (compareAtPrice > currentPrice && compareAtPrice > 0) {
          const discountPercent = Math.round(((compareAtPrice - currentPrice) / compareAtPrice) * 100);
          if (compareAt) {
            compareAt.textContent = formatMoney(compareAtPrice);
            compareAt.style.display = '';
          } else {
            const newCompare = document.createElement('compare-at-price');
            newCompare.className = 'text-subdued text-sm line-through';
            newCompare.textContent = formatMoney(compareAtPrice);
            salePrice.after(newCompare);
          }
          if (badge) {
            badge.innerHTML = '-' + formatMoney(compareAtPrice - currentPrice);
            badge.style.display = '';
          }
        } else {
          if (compareAt) compareAt.style.display = 'none';
          if (badge) badge.style.display = 'none';
        }
      }

      // Update checkbox
      if (checkbox) {
        checkbox.disabled = false;
        checkbox.dataset.upsellVariantId = currentVariantId;
        checkbox.dataset.upsellPrice = currentPrice;
      }

      // Check if this variant is already in cart
      checkCartStatus();
    }

    // Custom dropdown: toggle open/close and handle item selection
    if (hasVariants && dropdownTrigger && dropdownList) {
      dropdownTrigger.addEventListener('click', function(e) {
        e.stopPropagation();
        dropdownWrap.classList.toggle('is-open');
      });
      dropdownList.querySelectorAll('.product-upsell__dropdown-item').forEach(function(item) {
        item.addEventListener('click', function() {
          dropdownList.querySelectorAll('.product-upsell__dropdown-item').forEach(function(i) { i.classList.remove('is-selected'); });
          item.classList.add('is-selected');
          if (dropdownLabel) dropdownLabel.textContent = item.dataset.title;
          dropdownWrap.classList.remove('is-open');
          handleVariantChange(item);
        });
      });
      // Close dropdown when clicking outside
      document.addEventListener('click', function() {
        dropdownWrap.classList.remove('is-open');
      });
    }

    // Format money helper - match Shopify money format
    function formatMoney(cents) {
      // Try to get currency format from page, fallback to config currency
      const currencyCode = document.querySelector('[data-currency]')?.dataset.currency ||
                           window.Shopify?.currency?.active ||
                           fallbackCurrency;
      return window.SneakMoney.format(cents, currencyCode);
    }

    // Check if upsell is already in cart
    function checkCartStatus() {
      if (!currentVariantId) return;

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const inCart = cart.items.some(item => item.variant_id == currentVariantId);
          checkbox.checked = inCart;
          updateUpsellState(inCart);
        })
        .catch(err => console.error('Error checking cart:', err));
    }

    function updateUpsellState(inCart) {
      if (inCart) {
        upsellBlock.classList.add('product-upsell--in-cart');
      } else {
        upsellBlock.classList.remove('product-upsell--in-cart');
      }
    }

    // Handle toggle
    if (checkbox) {
      checkbox.addEventListener('change', function() {
        if (hasVariants && !currentVariantId) {
          // Prevent toggle if no variant selected — open and highlight dropdown
          this.checked = false;
          if (dropdownWrap) {
            dropdownWrap.classList.add('is-open');
            dropdownTrigger.style.borderColor = '#e74c3c';
            setTimeout(() => { dropdownTrigger.style.borderColor = ''; }, 1000);
          }
          return;
        }

        if (this.checked) {
          addToCart();
        } else {
          removeFromCart();
        }
      });
    }

    function addToCart() {
      if (!currentVariantId || !checkbox) {
        if (checkbox) checkbox.checked = false;
        return;
      }

      const formData = {
        items: [{
          id: currentVariantId,
          quantity: 1,
          properties: {
            '_upsell': 'true',
            '_product_upsell': 'true',
            '_upsell_discount': currentPrice,
            '_upsell_source': 'product-page-upsell',
            '_upsell_reason': 'erp-upsell',
            '_upsell_for': upsellBlock.dataset.upsellFor || ''
          }
        }]
      };

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
        checkbox.checked = true;
        updateUpsellState(true);
        // Trigger cart refresh event to match theme
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      })
      .catch(err => {
        console.error('Error adding to cart:', err);
        checkbox.checked = false;
      });
    }

    function removeFromCart() {
      if (!currentVariantId) return;

      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const item = cart.items.find(item => item.variant_id == currentVariantId);
          if (item) {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: item.key,
                quantity: 0
              })
            })
            .then(() => {
              checkbox.checked = false;
              updateUpsellState(false);
              // Trigger cart refresh event to match theme
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            })
            .catch(err => {
              console.error('Error removing from cart:', err);
              checkbox.checked = true;
            });
          } else {
            updateUpsellState(false);
          }
        })
        .catch(err => console.error('Error fetching cart:', err));
    }

    // Check cart status on load (only if variant is selected or no variants)
    if (!hasVariants) {
      checkCartStatus();
    }

    // Listen for cart updates
    document.addEventListener('cart:refresh', checkCartStatus);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Re-init after Section Rendering API swaps (injected scripts don't run);
     the block-level upsellReady flag keeps this idempotent. */
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 100); });
})();
